import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { saveAuth } from '../auth';
import { auth as authApi, onboarding as onboardingApi } from '../services/api';

function Cadastro() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [terms, setTerms] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [termsError, setTermsError] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [submitLabel, setSubmitLabel] = useState('Criar conta grátis');
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [submitStyle, setSubmitStyle] = useState({});

  function handleAuthSuccess(token, user) {
    saveAuth(token, user);
    if (typeof window.onLoginSuccess === 'function') {
      window.onLoginSuccess(token, user);
    }
  }

  async function getPostLoginRoute() {
    try {
      const data = await onboardingApi.getOnboarding();
      return data?.completed ? '/dashboard' : '/onboarding';
    } catch {
      return '/onboarding';
    }
  }

  function handlePasswordChange(val) {
    setPassword(val);
    let strength = 0;
    if (val.length >= 8) strength++;
    if (/[A-Z]/.test(val)) strength++;
    if (/[0-9]/.test(val)) strength++;
    if (/[^A-Za-z0-9]/.test(val)) strength++;
    setPasswordStrength(strength);
  }

  function getBarClass(index) {
    if (index >= passwordStrength) return 'ps-bar';
    const cls = passwordStrength <= 1 ? 'weak' : passwordStrength <= 2 ? 'medium' : 'strong';
    return `ps-bar ${cls}`;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    let valid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!name.trim()) { setNameError(true); valid = false; } else setNameError(false);
    if (!email || !emailRegex.test(email)) { setEmailError(true); valid = false; } else setEmailError(false);
    if (password.length < 8) { setPasswordError(true); valid = false; } else setPasswordError(false);
    if (confirmPassword !== password) { setConfirmPasswordError(true); valid = false; } else setConfirmPasswordError(false);
    if (!valid) return;
    if (!terms) { setTermsError(true); return; }
    setTermsError(false);

    setSubmitLabel('Criando conta...');
    setSubmitDisabled(true);

    try {
      const data = await authApi.register(name.trim(), email, password);
      handleAuthSuccess(data.token, data.user);
      const nextRoute = await getPostLoginRoute();

      setSubmitLabel('✓ Conta criada! Redirecionando...');
      setSubmitStyle({ background: 'linear-gradient(135deg, #4ADE80, #22c55e)' });
      setTimeout(() => navigate(nextRoute), 1500);
    } catch (err) {
      setSubmitLabel('Criar conta grátis');
      setSubmitDisabled(false);
      alert(err.message || 'Erro ao criar conta. Tente novamente.');
    }
  }

  return (
    <div className="page">
      {/* ESQUERDA */}
      <div className="left">
        <Link to="/" className="left-logo">
          <img src={require('../logo.png')} alt="PokerMind Brasil" style={{ height: '46px', objectFit: 'contain' }} />
        </Link>
        <div className="left-copy">
          <div className="left-tag left-tag-green">Comece grátis agora</div>
          <h2 className="left-title">Seu jogo.<br /><span className="grad">Elevado pela IA.</span></h2>
          <div className="left-benefits">
            <div className="benefit">
              <div className="benefit-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 8V4H8"/><rect x="2" y="8" width="20" height="12" rx="2"/><path d="M6 12h.01M10 12h.01M14 12h.01"/>
                </svg>
              </div>
              <div className="benefit-text">
                <strong>Coach IA 24/7 em português</strong>
                <span>Analise spots, calcule EV e receba feedback instantâneo em qualquer hora.</span>
              </div>
            </div>
            <div className="benefit">
              <div className="benefit-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
                </svg>
              </div>
              <div className="benefit-text">
                <strong>Análise real das suas mãos</strong>
                <span>Importe seu histórico do GGPoker e descubra onde você perde fichas.</span>
              </div>
            </div>
            <div className="benefit">
              <div className="benefit-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/>
                  <line x1="9" y1="3" x2="9" y2="18"/><line x1="15" y1="6" x2="15" y2="21"/>
                </svg>
              </div>
              <div className="benefit-text">
                <strong>Plano de estudo personalizado</strong>
                <span>Missão do dia, meta de 30 dias e trilha de evolução gerados por IA.</span>
              </div>
            </div>
          </div>
        </div>
        <div className="left-testimonial">
          <p className="testimonial-text-sm">"Depois do PokerMind, parei de jogar no automático. Cada decisão tem um motivo baseado em dados reais."</p>
          <div className="testimonial-author-sm">
            <div className="author-avatar-sm">RF</div>
            <div className="author-info-sm">
              <strong>Rafael F.</strong>
              <span>NL200 Regular · São Paulo</span>
            </div>
          </div>
        </div>
      </div>

      {/* DIREITA */}
      <div className="right">
        <div className="form-wrap">
          <div className="form-header">
            <h1>Criar sua conta</h1>
            <p>Já tem conta? <Link to="/login">Entrar agora</Link></p>
          </div>

          {/* Google OAuth */}
          <button
            type="button"
            className="btn-submit"
            disabled
            title="Em breve"
            style={{ background: '#1f1f1f', color: 'var(--muted)', opacity: 0.7, cursor: 'not-allowed', marginBottom: '0' }}
          >
            Cadastro com Google • Em breve
          </button>
          <div className="divider-form"><span>ou com email</span></div>

          <form id="registerForm" noValidate onSubmit={handleSubmit}>
            <div className={`form-group${nameError ? ' has-error' : ''}`}>
              <label htmlFor="reg-name">Seu nome</label>
              <input type="text" id="reg-name" className="form-input" placeholder="Como você quer ser chamado?"
                value={name} onChange={e => setName(e.target.value)} />
              <span className="error-msg">Por favor insira seu nome</span>
            </div>
            <div className={`form-group${emailError ? ' has-error' : ''}`}>
              <label htmlFor="reg-email">E-mail</label>
              <input type="email" id="reg-email" className="form-input" placeholder="seu@email.com"
                value={email} onChange={e => setEmail(e.target.value)} />
              <span className="error-msg">E-mail inválido</span>
            </div>
            <div className={`form-group${passwordError ? ' has-error' : ''}`}>
              <label htmlFor="reg-password">Senha</label>
              <div className="input-icon-wrap">
                <input type={showPassword ? 'text' : 'password'} id="reg-password" className="form-input"
                  placeholder="Mínimo 8 caracteres"
                  value={password} onChange={e => handlePasswordChange(e.target.value)} />
                <button type="button" className="input-icon"
                  onClick={() => setShowPassword(v => !v)}
                  style={{ color: showPassword ? 'var(--yellow)' : 'var(--muted)' }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                </button>
              </div>
              <div className="password-strength">
                <div className={getBarClass(1)} />
                <div className={getBarClass(2)} />
                <div className={getBarClass(3)} />
                <div className={getBarClass(4)} />
              </div>
              <span className="error-msg">Senha deve ter no mínimo 8 caracteres</span>
            </div>
            <div className={`form-group${confirmPasswordError ? ' has-error' : ''}`}>
              <label htmlFor="reg-confirm-password">Confirmar senha</label>
              <div className="input-icon-wrap">
                <input type={showConfirmPassword ? 'text' : 'password'} id="reg-confirm-password" className="form-input"
                  placeholder="Digite a senha novamente"
                  value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
                <button type="button" className="input-icon"
                  onClick={() => setShowConfirmPassword(v => !v)}
                  style={{ color: showConfirmPassword ? 'var(--yellow)' : 'var(--muted)' }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                </button>
              </div>
              <span className="error-msg">As senhas não coincidem</span>
            </div>
            <div className="terms">
              <input type="checkbox" id="terms-check" name="terms" checked={terms}
                onChange={e => { setTerms(e.target.checked); if (e.target.checked) setTermsError(false); }} />
              <label htmlFor="terms-check">
                Concordo com os <Link to="/termos" target="_blank">Termos de Uso</Link> e <Link to="/privacidade" target="_blank">Política de Privacidade</Link> do PokerMind Brasil
              </label>
            </div>
            {termsError && (
              <span className="error-msg" style={{display: 'block', marginBottom: '12px'}}>
                Você precisa aceitar os Termos de Uso para continuar.
              </span>
            )}
            <button type="submit" className="btn-submit" disabled={submitDisabled} style={submitStyle}>
              {submitLabel}
            </button>
            <div className="free-badge"><strong>✓ Grátis para sempre</strong> — sem cartão de crédito</div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Cadastro;
